import * as React from 'react';
import { IconProps } from '../types';

const IcMobile = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill={props?.fill ?? '#232F3E'}
        d="M9.283 12.878c0 .312.11.576.33.792.22.216.486.326.798.33h3.75c.308 0 .572-.11.792-.33.22-.22.33-.484.33-.792v-3.75c0-.244-.07-.462-.21-.654a1.1 1.1 0 0 0-.54-.402v.492c0 .156-.054.29-.162.402a.517.517 0 0 1-.402.162.557.557 0 0 1-.396-.162.565.565 0 0 1-.162-.402V8h-2.25v.564c0 .156-.056.29-.168.402a.521.521 0 0 1-.396.162.61.61 0 0 1-.402-.162.481.481 0 0 1-.162-.402v-.492c-.22.08-.4.214-.54.402-.14.188-.21.406-.21.654v3.75Zm.75 0v-3h4.5v3a.36.36 0 0 1-.108.264.36.36 0 0 1-.264.108h-3.75a.38.38 0 0 1-.27-.108.33.33 0 0 1-.108-.264Zm.378-4.314a.18.18 0 0 0 .054.132.18.18 0 0 0 .132.054.18.18 0 0 0 .132-.054.18.18 0 0 0 .054-.132V8h-.372v.564Zm.372 3.936h.75v-.75h-.75v.75Zm0-1.122h.75v-.75h-.75v.75ZM11.91 12.5h.75v-.75h-.75v.75Zm0-1.122h.75v-.75h-.75v.75Zm1.122 1.122h.75v-.75h-.75v.75Zm0-1.122h.75v-.75h-.75v.75Zm.75-2.814a.18.18 0 0 0 .054.132.18.18 0 0 0 .132.054.18.18 0 0 0 .132-.054.203.203 0 0 0 .06-.132V8h-.378v.564Z"
      />
    </g>
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M7.979 1.817h8.575-8.602.027Zm-1.257 1.95h11.063V17.97H6.722V3.766ZM8.88 23H7.98a2.074 2.074 0 0 1-2.074-2.074V3.074C5.905 1.93 6.833 1 7.979 1h8.549c1.145 0 2.074.929 2.074 2.074V20.926A2.074 2.074 0 0 1 16.527 23H8.88Zm1.849-3.551a.864.864 0 0 0 0 1.728h3.08a.864.864 0 0 0 0-1.728h-3.08Z"
      clipRule="evenodd"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M9.283 8h6v6h-6z" />
      </clipPath>
    </defs>
  </svg>
);

export default IcMobile;